import React from 'react';
import { personal } from '../data/resume';
import './Contact.css';

export default function Contact() {
  return (
    <section id="contact" className="section-wrap contact-wrap">
      <h2 className="section-title">Get in Touch</h2>
      <p className="contact-sub">
        Currently open to internships and full-time opportunities. Drop me an email or connect on LinkedIn.
      </p>
      <div className="contact-cta">
        <a className="btn btn-primary" href={`mailto:${personal.email}`}>
          {personal.email}
        </a>
        <a className="btn btn-outline" href={personal.linkedin} target="_blank" rel="noreferrer">
          LinkedIn ↗
        </a>
        <a className="btn btn-outline" href={personal.github} target="_blank" rel="noreferrer">
          GitHub ↗
        </a>
      </div>

      <footer className="footer">
        <div>Built with React · Designed by Riduvarshini R S</div>
        <div className="footer-dim mono">{personal.email} · {personal.phone}</div>
      </footer>
    </section>
  );
}
